import React, { CSSProperties, ReactNode } from 'react';
import { CircularProgress, styled } from '@mui/material';

const classesPrefix = 'overlaySpinner';

const classes = {
    loadingOverlay: `${classesPrefix}-loadingOverlay`,
    transparent: `${classesPrefix}-transparent`,
    spinnerContainer: `${classesPrefix}-spinnerContainer`,
};

const StyledDiv = styled('div')(({ theme }) => {
    return {
        [`&.${classes.loadingOverlay}`]: {
            position: 'absolute',
            height: '100%',
            width: '100%',
            top: 0,
            left: 0,
            backgroundColor: 'rgba(243, 243, 247, 0.5)',
            zIndex: theme.zIndex.modal,
        },
        [`&.${classes.transparent}`]: {
            backgroundColor: 'transparent',
        },
        [`& .${classes.spinnerContainer}`]: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
        },
    };
});

const OverlaySpinner = ({
    noBackground,
    overlayStyle,
    children,
}: {
    noBackground?: boolean;
    overlayStyle?: CSSProperties;
    children?: ReactNode;
}): React.JSX.Element => {
    return (
        <StyledDiv className={`${classes.loadingOverlay} ${noBackground ? classes.transparent : ''}`} style={overlayStyle}>
            <div className={classes.spinnerContainer}>
                <CircularProgress />
                {children}
            </div>
        </StyledDiv>
    );
};

export default OverlaySpinner;
